import url from "../../../utils/url";
import regionalTariffSteps from '../utils/regionalTariffSteps'

export default {
  data () {
    return {
      tabView: 'tab1',
      fields: {}
    }
  },
  created () {
    this.update()
  },
  computed: {
    item () {
      return this.$store.getters.readUrlEndpoint(this.getItemEndpoint(this.$route))
    },
    regionalTariffSteps () {
      return regionalTariffSteps
    }
  },
  methods: {
    submitModalForm () {
      let route = url.getRedirectRoute(this.$route)
      this.$router.push(route)
    },
    update() {
      this.initFieldsAfterLoad()
    },
    initFieldsAfterLoad() {
      this.fields = Object.assign({}, this.item)
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
